import { SpinnerComponent } from './spinner.component';
import { CommonModule } from '@angular/common';
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { MaterialModule } from '../../material.module';
import { MomentModule } from 'ngx-moment';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { RankComponent } from './rank.component';
import { TimePickerComponent } from '../ui';
import { DayPickerComponent } from './dayPicker.component';
import { TopicImageComponent } from './topicImage.component';
import { SlackLinkButtonComponent } from './slackLinkButton.component';
import { NewIndicatorComponent } from './newIndicator.component';
import { ConfirmationDialogComponent } from './confirmationDialog.component';
import { RouterModule } from '@angular/router';
import { SelectUserDialogComponent } from './selectUserDialog.component';
import { InvitationManagerComponent } from './invitationManager.control';
import { CurrentUserInvitationManagerComponent } from './currentUserInvitationManager.component';
import { FileUploadLinkComponent } from './fileUploadLink.component';
import { ItemEditorComponent } from './itemEditor.component';
import { AttensaEditorModule } from '../attensaEditor/attensaEditor.module';
import { MaterialFileInputModule } from 'ngx-material-file-input';
import { TenantSuspendedDialogComponent } from './tenantSuspendedDialog.component';
import { MenuButtonComponent } from './menuButton.component';
import { BriefingPreviewComponent } from './briefingPreview.component';
import { CurationRankComponent } from './curationRank.component';
import { HelpLinkComponent } from './helpLink.component';
import { EmailAddressDialogComponent } from './emailAddressDialog.component';
import { LoginButtonComponent } from './loginButton.component';
import { RegisterButtonComponent } from './registerButton.component';
import { PublicSigninDialogComponent } from './publicSigninDialog.component';
import { MagicLinkSentSnackbarMessageComponent } from './magicLinkSentSnackbarMessage.component';
import { JamBottomSheetComponent } from './jamBottomSheet.component';
import { PipesModule } from '../pipes/pipes.module';

@NgModule({
    imports: [
        AttensaEditorModule,
        CommonModule,
        FlexLayoutModule,
        FormsModule,
        ReactiveFormsModule,
        HttpClientModule,
        MaterialModule,
        MomentModule,
        MaterialFileInputModule,
        PipesModule,
        RouterModule,
        InfiniteScrollModule,
    ],
    declarations: [
        BriefingPreviewComponent,
        ConfirmationDialogComponent,
        CurationRankComponent,
        CurrentUserInvitationManagerComponent,
        DayPickerComponent,
        EmailAddressDialogComponent,
        FileUploadLinkComponent,
        HelpLinkComponent,
        InvitationManagerComponent,
        ItemEditorComponent,
        JamBottomSheetComponent,
        LoginButtonComponent,
        MagicLinkSentSnackbarMessageComponent,
        MenuButtonComponent,
        NewIndicatorComponent,
        PublicSigninDialogComponent,
        RankComponent,
        RegisterButtonComponent,
        SelectUserDialogComponent,
        SlackLinkButtonComponent,
        SpinnerComponent,
        TenantSuspendedDialogComponent,
        TimePickerComponent,
        TopicImageComponent
    ],
    exports: [
        BriefingPreviewComponent,
        ConfirmationDialogComponent,
        CurationRankComponent,
        CurrentUserInvitationManagerComponent,
        DayPickerComponent,
        EmailAddressDialogComponent,
        HelpLinkComponent,
        FileUploadLinkComponent,
        InvitationManagerComponent,
        ItemEditorComponent,
        JamBottomSheetComponent,
        LoginButtonComponent,
        MenuButtonComponent,
        NewIndicatorComponent,
        PublicSigninDialogComponent,
        RankComponent,
        RegisterButtonComponent,
        SelectUserDialogComponent,
        SlackLinkButtonComponent,
        SpinnerComponent,
        TenantSuspendedDialogComponent,
        TimePickerComponent,
        TopicImageComponent
    ],
    entryComponents: [
        ConfirmationDialogComponent,
        EmailAddressDialogComponent,
        JamBottomSheetComponent,
        SelectUserDialogComponent,
        TenantSuspendedDialogComponent
    ]
})
export class GeneralModule {
}